/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DraftInputs */

const en_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const es_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrador`)
};

const fr_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon`)
};

const de_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf`)
};

const ja_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下書き`)
};

const zh_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿`)
};

const ar_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسودة`)
};

const id_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf`)
};

const it_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozza`)
};

const ru_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Черновик`)
};

const pt_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho`)
};

const ko_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임시저장`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {DraftInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const draft = /** @type {((inputs?: DraftInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DraftInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft(inputs)
	if (locale === "es") return es_draft(inputs)
	if (locale === "fr") return fr_draft(inputs)
	if (locale === "de") return de_draft(inputs)
	if (locale === "ja") return ja_draft(inputs)
	if (locale === "zh") return zh_draft(inputs)
	if (locale === "ar") return ar_draft(inputs)
	if (locale === "id") return id_draft(inputs)
	if (locale === "it") return it_draft(inputs)
	if (locale === "ru") return ru_draft(inputs)
	if (locale === "pt") return pt_draft(inputs)
	return ko_draft(inputs)
});